export const getFields = (state) => {
    return state.constructs.fields;
}

export const getSectionFields = section => state => {
    if (section === undefined) return [];
    return getFields(state).filter(field => field.parent[0].id === section.id);
}

export const getFieldsOfParentFields = parentField => state => {
    if (parentField === undefined) return [];
    return getFields(state).filter(field => field.parent[0].id === parentField.id);
}

